import { DataBean } from "../DataBean";

export class TimeEventCatalog extends DataBean {



    public async getTimeEventCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTimeEventCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }
    
}